if(!customElements.get('product-media')){
    class ProductMedia extends HTMLElement {
        constructor(){
            super();

            this.productMediaInner = this.querySelector('product-media-inner');
            this.slides = this.querySelectorAll('product-media-slide');

            this.currentIndex = 1;
            this.isDragging = false;
            this.isZoomed = false;

            this.startTranslateX = 0;
            this.endTranslateX = 0;
            this.currentTranslate = 0;
            this.prevTranslate = 0;
            this.animationID = null;
            this.dragThreshold = 40;

            // pagination
            this.section = this.closest('.section-product');
            this.popupPagination = this.section.querySelector('product-pagination-popup, product-pagination');
            if(this.popupPagination){
                if(this.popupPagination.classList.contains('popup')){
                    this.initializePaginationPopup();
                }else{
                    this.initializePaginationColumn();
                }
            }

            // navigation
            this.navigationWrapper = this.querySelector('product-navigation');
            if(this.navigationWrapper){
                this.buttonPrev = this.querySelector('product-navigation-arrow[data-direction="prev"]');
                this.buttonNext = this.querySelector('product-navigation-arrow[data-direction="next"]');
            }

            if(this.slides.length > 0){
                this.initializeSlides();
            }

            // delay startMedia() until media-wrapper is ready
            customElements.whenDefined('media-wrapper').then(() => {
                this.startMedia();
            });

            this.updateAccessibility();
        }

        initializePaginationPopup(){
            this.buttonClosePagination = this.popupPagination.querySelector('.button-close');
            this.paginationItems = this.popupPagination.querySelectorAll('product-pagination-thumbnail');

            if(this.paginationItems.length == 0) return;

            // open popup
            this.slides.forEach(item => { // pagination button
                const buttonPagination = item.querySelector('.button-pagination');
                if(buttonPagination){
                    buttonPagination.addEventListener("click", this.openPaginationPopup.bind(this));
                }
            });

            // close popup
            if(this.buttonClosePagination){
                this.buttonClosePagination.addEventListener("click", this.closePaginationPopup.bind(this));
                this.buttonClosePagination.addEventListener("keydown", e => {
                    if(e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        setTimeout(() => {
                            this.closePaginationPopup(e);
                        }, 100);
                    }
                });
            }
            this.popupPagination.addEventListener("click", e => {
                if(e.target === this.popupPagination) this.closePaginationPopup();
            });
            this.popupPagination.addEventListener("keydown", e => {
                if(e.key === 'Escape') {
                    setTimeout(() => {
                        this.closePaginationPopup();
                    }, 100);
                }
            });

            // pagination
            this.paginationItems.forEach(item => {
                item.addEventListener('click', (e) => {
                    const currentIndex = parseInt(item.dataset.index);
                    if(!isNaN(currentIndex)){
                        this.currentIndex = currentIndex;
                        this.updateSlide();
                        this.closePaginationPopup();
                    }
                });
                item.addEventListener("keydown", e => {
                    if(e.key === 'Enter'){
                        const currentIndex = parseInt(item.dataset.index);
                        if(!isNaN(currentIndex)){
                            this.currentIndex = currentIndex;
                            this.updateSlide();
                            setTimeout(() => {
                                this.closePaginationPopup();
                            }, 100);
                        }
                    }
                });
            });
        }

        initializePaginationColumn(){
            this.paginationItems = this.popupPagination.querySelectorAll('product-pagination-thumbnail');
            if(this.paginationItems.length == 0) return;

            // pagination
            this.paginationItems.forEach(item => {
                item.addEventListener('click', (e) => {
                    const currentIndex = parseInt(item.dataset.index);
                    if(!isNaN(currentIndex)){
                        this.currentIndex = currentIndex;
                        this.updateSlide();
                    }
                });
            });
        }

        initializeSlides(){
            const start = (x) => {
                if(this.isZoomed) return;
                this.isDragging = true;
                this.startTranslateX = x;
                this.currentTranslate = -((this.currentIndex - 1) * this.offsetWidth);
                this.prevTranslate = this.currentTranslate;

                this.productMediaInner.style.transition = 'none';

                this.animationID = requestAnimationFrame(this.animate.bind(this));
            }

            const move = (x) => {
                if(!this.isDragging) return;
                if(this.isZoomed) return;

                var delta = x - this.startTranslateX;

                if(this.currentIndex === 1 && delta > 0){
                    delta = 0;
                }else if(this.currentIndex === this.slides.length && delta < 0){
                    delta = 0;
                }

                this.currentTranslate = this.prevTranslate + delta;
            }

            const end = (x) => {
                if(!this.isDragging) return;
                if(this.isZoomed) return;

                const moveBy = x - this.startTranslateX;
                this.isDragging = false;
                cancelAnimationFrame(this.animationID);

                // snap decision
                if(moveBy < -this.dragThreshold && this.currentIndex < this.slides.length){
                    this.nextSlide();
                }else if(moveBy > this.dragThreshold && this.currentIndex > 1){
                    this.previousSlide();
                }else {
                    this.updateSlide(); // snap back
                }
            }

            // mouse
            this.addEventListener('mousedown', (e) => start(e.clientX));
            this.addEventListener('mousemove', (e) => move(e.clientX));
            this.addEventListener('mouseup', (e) => end(e.clientX));
            this.addEventListener('mouseleave', (e) => end(e.clientX));
        
            // touch
            this.addEventListener('touchstart', (e) => start(e.touches[0].clientX));
            this.addEventListener('touchmove', (e) => move(e.touches[0].clientX));
            this.addEventListener('touchend', (e) => end(e.changedTouches[0].clientX));

            // resize
            window.addEventListener("resize", this.resizeSlide.bind(this));

            // navigation
            if(this.buttonPrev){
                this.buttonPrev.addEventListener('click', (e) => {
                    if(this.currentIndex == 1) return;
                    const newIndex = this.currentIndex - 1;
                    this.currentIndex = newIndex;
                    this.updateSlide();
                });
                this.buttonPrev.addEventListener("keydown", e => {
                    if(this.currentIndex == 1) return;
                    if(e.key === 'Enter'){
                        const newIndex = this.currentIndex - 1;
                        this.currentIndex = newIndex;
                        this.updateSlide();
                    }
                });
            }
            if(this.buttonNext){
                this.buttonNext.addEventListener('click', (e) => {
                    if(this.currentIndex == this.slides.length) return;
                    const newIndex = this.currentIndex + 1;
                    this.currentIndex = newIndex;
                    this.updateSlide();
                });
                this.buttonNext.addEventListener("keydown", e => {
                    if(this.currentIndex == this.slides.length) return;
                    if(e.key === 'Enter'){
                        const newIndex = this.currentIndex + 1;
                        this.currentIndex = newIndex;
                        this.updateSlide();
                    }
                });
            }
        }

        animate(){
            if (!this.isDragging) return;
            if (!this.productMediaInner) return;

            this.productMediaInner.style.transform = `translateX(${this.currentTranslate}px)`;
            this.animationID = requestAnimationFrame(this.animate.bind(this));
        }

        nextSlide(){
            if(this.currentIndex == this.slides.length) this.currentIndex = 1;
            else this.currentIndex = this.currentIndex + 1;

            this.updateSlide();
        }

        previousSlide(){
            if(this.currentIndex === 1) return;
            this.currentIndex = this.currentIndex - 1;

            this.updateSlide();
        }

        updateSlide(fastTransition = false){
            if(!this.productMediaInner) return;

            if(fastTransition){
                this.productMediaInner.style.transition = "all 0s ease-in-out";
            }else{
                this.productMediaInner.style.transition = "all 1s ease-in-out";
            }
            this.productMediaInner.style.transform = `translateX(-${(this.currentIndex - 1) * this.productMediaInner.offsetWidth}px)`;
        
            this.buttonPrev.setAttribute('aria-hidden', this.currentIndex == 1? 'true' : 'false');
            if(this.currentIndex == 1){ this.buttonPrev.setAttribute('inert', ''); } else { this.buttonPrev.removeAttribute('inert'); }
            this.buttonNext.setAttribute('aria-hidden', this.currentIndex == this.slides.length? 'true' : 'false');
            if(this.currentIndex == this.slides.length){ this.buttonNext.setAttribute('inert', ''); } else { this.buttonNext.removeAttribute('inert'); }
            
            this.closeMedia();
            this.startMedia();

            this.updateAccessibility();
        }

        updateAccessibility(){
            const mediaSlides = this.querySelectorAll('product-media-slide');
            mediaSlides.forEach(slide => {
                const mediaIndexId = parseInt(slide.dataset.index);
                if (isNaN(mediaIndexId)) return; 

                const tabEnabledElements = slide.querySelectorAll('a, [tabindex], button, input, iframe');
                if(tabEnabledElements.length > 0){
                    tabEnabledElements.forEach(item => {
                        item.setAttribute('tabindex', mediaIndexId === this.currentIndex? '0' : '-1');
                    });
                }
            });
        }

        updateSlideByIndex(index = 1){
            this.currentIndex = index;
            this.updateSlide(true);
        }

        resizeSlide(){
            if(!this.productMediaInner) return;

            this.productMediaInner.style.transition = "none";
            this.productMediaInner.style.transform = `translateX(-${(this.currentIndex - 1) * this.productMediaInner.offsetWidth}px)`;
        }

        disableSlides(){
            this.isZoomed = true;
        }

        enableSlides(){
            this.isZoomed = false;
        }

        closeMedia(){
            this.slides.forEach(item => {
                const mediaWrapper = item.querySelector('media-wrapper');
                if(mediaWrapper.dataset.type === 'image'){
                    mediaWrapper.zoomOutImage();
                }else if(mediaWrapper.dataset.type === 'external_video'){
                    mediaWrapper.stopExternalVideo();
                }else if(mediaWrapper.dataset.type === 'video'){
                    mediaWrapper.stopVideo();
                }else if(mediaWrapper.dataset.type === 'model'){
                    mediaWrapper.zoomOutModel();
                }
            });
        }

        startMedia(){
            const currentSlide = this.querySelector(`product-media-slide[data-index="${this.currentIndex}"]`);
            const mediaWrapper = currentSlide?.querySelector('media-wrapper');
            if(!mediaWrapper) return;

            if(mediaWrapper.dataset.type === 'external_video'){
                mediaWrapper.startExternalVideo();
            }else if(mediaWrapper.dataset.type === 'video'){
                mediaWrapper.startVideo();
            }
        }

        openPaginationPopup(){
            this.popupPagination.setAttribute('data-hidden', 'false');
            this.popupPagination.removeAttribute('inert');

            document.body.style.overflow = 'hidden';
            document.documentElement.style.overflow = 'hidden';

            this.previouslyFocusedElement = document.activeElement;

            FocusTrap.activate(this.popupPagination);
            this.addFocus();

            this.resizeSlide();
        }

        closePaginationPopup(){
            FocusTrap.deactivate(this.popupPagination);

            this.popupPagination.setAttribute('data-hidden', 'true');
            this.popupPagination.setAttribute('inert', '');

            document.body.style.overflow = '';
            document.documentElement.style.overflow = '';

            if(this.previouslyFocusedElement){
                this.previouslyFocusedElement.focus();
            }

            this.resizeSlide();
        }

        addFocus(){
            if(this.paginationItems.length > 0){
                setTimeout(() => {
                    this.paginationItems[0].focus();
                }, 100);
            }
        }
    }
    
    customElements.define('product-media', ProductMedia);
}

if(!customElements.get('media-wrapper')){
    class Media extends HTMLElement {
        constructor(){
            super();

            this.productMedia = this.closest('product-media');
            if(!this.productMedia) return;

            this.currentIndex = this.productMedia.currentIndex;
            if(!this.currentIndex) return;

            this.type = this.dataset.type;
            if(this.type === 'image') this.initializeImage();
            if(this.type === 'model') this.initializeModel();
            if(this.type === 'external_video') this.initializeExternalVideo();
            if(this.type === 'video') this.initializeVideo();
        }

        initializeImage(){
            this.image = this.querySelector('img');
            this.imageWrapper = this.querySelector(".image-wrapper");
            this.enabledZoom = this.dataset.enableZoom == 'true';
            if(!this.enabledZoom) return;

            this.scrollDetected = false;
            this.slideDetected = false;

            this.isZoomed = false;
            this.isDragging = false;
            this.initialX = 0;
            this.initialY = 0;
            this.numClick = 0;

            this.lastMoveTime = 0;
            this.lastX = 0;
            this.lastY = 0;
            this.velocityX = 0;
            this.velocityY = 0;
            this.doubleTapThreshold = 300; // Time in ms to detect double tap

            this.isScrolling;
            this.touchStartY = 0;
            this.touchStartX = 0;
            this.touchEndY = 0;
            this.touchEndX = 0;
            this.zoomDetected = false;

            this.buttonZoom = this.querySelector('.button-zoom');
            this.buttonZoom.addEventListener('click', () => {
                this.zoomInImage();
            });
            this.addEventListener('dblclick', () => {
                if(this.isZoomed) this.zoomOutImage();
                else this.zoomInImage();
            });

            this.buttonClose = this.querySelector('.button-close');
            this.buttonClose.addEventListener('click', () => {
                this.zoomOutImage();
            });

            const startDragging = (e) => {
                if(!this.isZoomed) return;
                e.preventDefault();

                this.isDragging = true;
                const event = e.touches ? e.touches[0] : e;
                this.startX = event.clientX - this.initialX;
                this.startY = event.clientY - this.initialY;
                this.image.style.cursor = 'grabbing';

                this.lastMoveTime = Date.now();
                this.lastX = event.clientX;
                this.lastY = event.clientY;
            }

            const moveDragging = (e) => {
                if(!this.isDragging) return;
                if(this.scrollDetected) return;
                if(!this.isZoomed) return;
                if(this.slideDetected) return;

                const event = e.touches ? e.touches[0] : e;
                const currentX = event.clientX;
                const currentY = event.clientY;
                const currentTime = Date.now();

                const deltaX = currentX - this.lastX;
                const deltaY = currentY - this.lastY;
                const deltaTime = currentTime - this.lastMoveTime;  

                this.velocityX = deltaX / deltaTime;
                this.velocityY = deltaY / deltaTime;
    
                this.lastMoveTime = currentTime;
                this.lastX = currentX;
                this.lastY = currentY;
    
                const dragFactor = 5;

                this.initialX = event.clientX - this.startX + this.velocityX * dragFactor;
                this.initialY = event.clientY - this.startY + this.velocityY * dragFactor;

                const imageRect = this.image.getBoundingClientRect();
                const wrapperRect = this.imageWrapper.getBoundingClientRect();

                const maxTranslateX = wrapperRect.width / 2;
                const maxTranslateY = wrapperRect.height / 2;
                const minTranslateX = wrapperRect.width - imageRect.width * 2 / 2;
                const minTranslateY = wrapperRect.height - imageRect.height * 2 / 2;

                const translateX = Math.min(Math.max(this.initialX, (minTranslateX / 2)), maxTranslateX);
                const translateY = Math.min(Math.max(this.initialY, (minTranslateY / 2)), maxTranslateY);
    
                this.initialX = translateX;
                this.initialY = translateY;
    
                this.image.style.transform = `translate3d(${translateX}px, ${translateY}px, 0px) scale3d(2, 2, 1)`;
            }

            const endDragging = (e) => {
                if(this.scrollDetected) return;
                if(this.slideDetected) return;

                this.isDragging = false;
                this.image.style.cursor = 'grab';
            }

            const startTouch = (e) => {
                if(e.touches && e.touches.length > 1){
                    this.zoomDetected = true;
                    this.scrollDetected = false;
                }else{
                    this.zoomDetected = false;
                    this.touchStartX = e.touches[0].clientX;
                    this.touchStartY = e.touches[0].clientY;
                    this.detectScrolling(e);
                }

                if(this.scrollDetected == false){
                    startDragging(e);
                    document.body.classList.add('overflow-hidden');
                }
            }

            const endTouch = (e) => {
                if(this.scrollDetected) return;
                endDragging(e);

                const currentTime = new Date().getTime();
                const tapInterval = currentTime - this.lastTapTime;

                if(tapInterval < this.doubleTapThreshold && tapInterval > 0){
                    if(this.isZoomed){ // detect a double tap
                        this.zoomOutImage();
                    }else{
                        this.zoomInImage();
                    }
                }

                this.lastTapTime = currentTime;

                setTimeout(() => {
                    document.body.classList.remove('overflow-hidden');
                }, 1000);
            }

            this.addEventListener("mousedown", (e) => startDragging(e));
            this.addEventListener("mousemove", (e) => moveDragging(e));
            this.addEventListener("mouseup", (e) => endDragging(e));
            this.addEventListener("mouseleave", (e) => endDragging(e));

            this.addEventListener("touchstart", (e) => startTouch(e), { passive: false });
            this.addEventListener("touchmove", (e) => moveDragging(e), { passive: false });
            this.addEventListener("touchend", (e) => endTouch(e));
        }

        detectScrolling(e){
            if(this.isZoomed){
                this.scrollDetected = false;
            }else if(!this.zoomDetected){
                this.touchEndY = e.touches[0].clientY;
                this.touchEndX = e.touches[0].clientX;

                clearTimeout(this.isScrolling);
                this.isScrolling = setTimeout(() => {
                    const deltaY = Math.abs(this.touchEndY - this.touchStartY);
                    const deltaX = Math.abs(this.touchEndX - this.touchStartX);
            
                    this.scrollDetected = deltaY > deltaX;
                }, 100);
            }else{
                this.scrollDetected = false;
            }
        }

        zoomInImage(){
            if(!this.enabledZoom) return;
            if(this.isZoomed) return;

            this.productMedia.disableSlides();

            this.image.style.transform = 'scale3d(2, 2, 1)';
            this.isZoomed = true;
            this.buttonClose.classList.remove('hidden');
            this.buttonZoom.classList.add('hidden');
        }

        zoomOutImage(){
            if(!this.enabledZoom) return;

            this.image.style.transform = 'scale3d(1, 1, 1)';
            this.isZoomed = false;
            this.image.style.top = 0;
            this.image.style.left = 0;
            this.initialX = 0;
            this.initialY = 0;

            this.productMedia.enableSlides();
            this.buttonClose.classList.add('hidden');
            this.buttonZoom.classList.remove('hidden');
        }

        initializeModel(){
            this.buttonZoom = this.querySelector('.button-zoom');
            if(!this.buttonZoom) return;

            this.modelViewer = this.querySelector('.model-viewer');
            this.modelThumbnail = this.querySelector('.model-thumbnail');
            this.template = this.querySelector('template');

            this.buttonZoom.addEventListener('click', this.zoomInModel.bind(this));
        }

        zoomInModel(){
            if(this.modelViewer.innerHTML === ''){
                this.modelViewer.append(this.template.content);
            }

            this.buttonClose = this.querySelector('.button-close');
            if(this.buttonClose){
                this.buttonClose.addEventListener('click', (e) => {
                    this.zoomOutModel();
                });
            }

            this.productMedia.disableSlides();
            this.modelThumbnail.classList.add('hidden');
            this.modelViewer.setAttribute('data-active', 'true');
        }

        zoomOutModel(){
            this.productMedia.enableSlides();
            this.modelThumbnail?.classList.remove('hidden');
            this.modelViewer?.setAttribute('data-active', 'false');
        }

        initializeExternalVideo(){
            this.iframe = this.querySelector('iframe');
            this.thumbnail = this.querySelector('.video-thumbnail');
        }

        startExternalVideo(){
            if(!this.iframe) return;

            if(this.thumbnail){
                this.thumbnail.style.opacity = '0';
                this.thumbnail.style.visibility = 'hidden';
                this.thumbnail.style.transitionDuration = '0s';
            }

            const play = () => {
                // youtube
                this.iframe.contentWindow.postMessage('{"event":"command","func":"mute","args":""}', '*');
                this.iframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');

                // video
                var vimeoUrl = new URL(this.iframe.src);
                if(vimeoUrl.hostname.includes('vimeo.com')){
                    const vimeoMuteData = {
                        method: 'setVolumn',
                        value: 0, // set volumn to 0 (mute)
                    };
                    const vimeoData = { method: 'play' }

                    this.iframe.contentWindow.postMessage(JSON.stringify(vimeoMuteData), "*");
                    this.iframe.contentWindow.postMessage(JSON.stringify(vimeoData), "*");
                }
            }

            if(this.iframe.getAttribute('src') != ''){ // src already exists
                if(this.iframe.contentWindow) play();
                return;
            }

            const iframeSrc = this.iframe.dataset.src;
            this.iframe.setAttribute('src', iframeSrc);
            this.iframe.onload = function(){
                play();
            }

            this.productMedia.disableSlides();
        }

        stopExternalVideo(){
            if(!this.iframe) return;

            // youtube
            if(this.iframe.contentWindow){
                this.iframe.contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', '*');
            }

            // vimeo
            const vimeoUrl = new URL(this.iframe.src);
            if(vimeoUrl.hostname.includes('vimeo.com')){
                const vimeoData = {
                    method: 'pause'
                };

                const seekData = {
                    method: 'setCurrentTime',
                    value: 0
                };

                this.iframe.contentWindow.postMessage(JSON.stringify(vimeoData), vimeoUrl.origin);
                this.iframe.contentWindow.postMessage(JSON.stringify(seekData), vimeoUrl.origin);
            }

            if(this.thumbnail){
                this.thumbnail.style.opacity = '1';
                this.thumbnail.style.visibility = 'visible';
                this.thumbnail.style.transition = 'all 0.5s ease-in';
            }
        }

        initializeVideo(){
            this.video = this.querySelector('video');
        }

        startVideo(){
            if(!this.video) return;

            this.video.play();
            this.productMedia.disableSlides();
        }

        stopVideo(){
            if(!this.video) return;

            this.video.pause();
            this.video.currentTime = 0;
        }
    }

    customElements.define('media-wrapper', Media);
}